import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await axios.post(`${API}/auth/forgot-password`, { email }); } catch (err) { console.error("forgot-password request failed:", err); }
    setSent(true); setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#090D14] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img src="/betti-logo.jpg" alt="Betti SRL" className="w-12 h-12 rounded-xl object-cover bg-white shadow-lg" />
          <h1 className="font-head font-bold text-xl text-slate-100">Betti SRL</h1>
        </div>
        <div className="bg-[#121824] border border-[#222D42] rounded-2xl p-6 shadow-2xl space-y-4">
          <h2 className="font-head text-lg font-semibold text-slate-100">Recupera password</h2>
          {sent ? (
            <p data-testid="forgot-confirmation" className="text-sm text-slate-400">Se l'email è registrata, riceverai a breve un link per reimpostare la password. Controlla anche lo spam.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-xs uppercase tracking-wider text-slate-500 font-medium block mb-1.5">Email</label>
                <input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#1A2335] border border-[#222D42] rounded-lg px-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-amber-500/50" placeholder="tua@email.it" />
              </div>
              <button data-testid="forgot-submit-button" type="submit" disabled={loading} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Invia link
              </button>
            </form>
          )}
          <Link to="/login" className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-amber-400 transition-colors"><ArrowLeft className="w-3.5 h-3.5" /> Torna all'accesso</Link>
        </div>
      </div>
    </div>
  );
}
